import { dhw_temp_sensor_id } from 'console/climatic/constants';
import { DHWControlType, guess_dhw_control_type, } from 'console/climatic/utils/dhw-control-type';
import { boiler_adapter_ot_color, getSensorColor, } from 'z3k-settings/components/utils/ColorPicker4bit';
import { get_temperature_sensors } from 'z3k-parser/lib/z3k-selectors';
import { AnalogTemperatureSensor, BoilerAdapter, RadioSensor, WiredTemperatureSensor, } from 'z3k-config';
import { createSelector } from '@reduxjs/toolkit';
import { selectEnabledBoilerAdapters } from '../../utils/open-therm';
import { z3kOwaMultiplier } from 'z3k-parser/lib/owa';
import { owaAxis } from 'console/tabs/graphs/components/graph/utils/owa-axes';
import { fixObjectName } from 'z3k-settings/utils/fix-object-name';
import { select_boiler_adapter_limits } from 'z3k-parser/parser/state/sensors/utils';
export const isStatementForDhw = (thermometer_id, z3k_config, circuit) => {
    if (dhw_temp_sensor_id === thermometer_id && circuit) {
        const dhw_control_type = guess_dhw_control_type(z3k_config, circuit);
        return (dhw_control_type !== DHWControlType.FLOW_DHW &&
            dhw_control_type !== DHWControlType.BOILER_PLUS_DHW_BOILER &&
            dhw_control_type !== DHWControlType.OFF);
    }
    return false;
};
export function getThermometers(z3k_config) {
    const boiler_adapter_sensors = selectEnabledBoilerAdapters(z3k_config).flatMap((ba) => {
        return BoilerAdapter.getAvailableOTTemperatures(ba);
    });
    const internet_temps = WiredTemperatureSensor.get.where(z3k_config, WiredTemperatureSensor.isInternetTemp);
    return [
        ...get_temperature_sensors(z3k_config),
        ...boiler_adapter_sensors,
        ...internet_temps,
    ];
}
export function getWiredSensorThermometer(thermometer) {
    const { id, name, serial } = thermometer;
    const multiplier = z3kOwaMultiplier(thermometer);
    const limits = WiredTemperatureSensor.getLimits(thermometer, multiplier);
    const color = getSensorColor(WiredTemperatureSensor, thermometer);
    const axis_key = owaAxis(serial) ?? 'temperature';
    const owa = {
        axis_key,
        multiplier,
    };
    const is_internet_thermometer = WiredTemperatureSensor.isInternetTemp(thermometer);
    return { id, name: fixObjectName(name), owa, limits, color, is_internet_thermometer };
}
export function getRadioSensorThermometer(thermometer) {
    const { id, name, serial } = thermometer;
    const limits = RadioSensor.getLimits(thermometer);
    const color = getSensorColor(RadioSensor, thermometer);
    const axis_key = owaAxis(serial) ?? 'temperature';
    const owa = {
        axis_key,
    };
    return {
        id,
        name: fixObjectName(name),
        limits,
        color,
        owa,
    };
}
export function getAnalogSensorThermometer(thermometer) {
    const { id, name } = thermometer;
    const color = getSensorColor(AnalogTemperatureSensor, thermometer);
    const limits = AnalogTemperatureSensor.getLimits(thermometer);
    return {
        id,
        name: fixObjectName(name),
        limits,
        color,
    };
}
const select_heating_circuit_limits = createSelector((config) => config, (_, sensor) => sensor, select_boiler_adapter_limits);
export function getBoilerAdapterThermometer(thermometer, z3k_config, index) {
    const { id: boiler_adapter_id, ot_name, name: sensor_name } = thermometer;
    const id = (boiler_adapter_id + Number(`0.${index}`));
    const color = boiler_adapter_ot_color[0];
    const { heating_circuit_id, limits } = select_heating_circuit_limits(z3k_config, thermometer);
    const parent_boiler_adapter = BoilerAdapter.get.byId(z3k_config, boiler_adapter_id);
    const name = `${parent_boiler_adapter?.name ?? ''} ${sensor_name} ЦШ`;
    const open_therm = {
        heating_circuit_id,
        boiler_adapter_id,
        ot_name,
    };
    return {
        id,
        name,
        open_therm,
        limits,
        color,
    };
}
